import { CharacterResult } from "common/character/dto/CharacterResult";
import { InputWayTextCharElement } from "common/topic/input_way_text";

export function isNotPopulatedCharacter(
  textCharElement: InputWayTextCharElement
): boolean {
  let res: boolean = false;
  if (textCharElement.isCharacter) {
    const character = textCharElement.value as CharacterResult;
    res = character.pronounce === "" && character.meaning === "";
  }

  return res;
}
